<lib-toast class="ngb-toasts" aria-live="polite" aria-atomic="true"></lib-toast>

<router-outlet></router-outlet>
